import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { RegisterConfirmationApproveModalComponent } from './register-confirmation-approve-modal/register-confirmation-approve-modal.component';
import { RegisterConfirmationDetailsDrawerComponent } from './register-confirmation-details-drawer/register-confirmation-details-drawer.component';
import { RegisterConfirmationErrorModalComponent } from './register-confirmation-error-modal/register-confirmation-error-modal.component';
import { RegisterConfirmationFilterComponent } from './register-confirmation-filter/register-confirmation-filter.component';
import { RegisterConfirmationRejectModalComponent } from './register-confirmation-reject-modal/register-confirmation-reject-modal.component';
import { RegisterConfirmationComponent } from './register-confirmation.component';

@NgModule({
  declarations: [
    RegisterConfirmationComponent,
    RegisterConfirmationFilterComponent,
    RegisterConfirmationApproveModalComponent,
    RegisterConfirmationRejectModalComponent,
    RegisterConfirmationDetailsDrawerComponent,
    RegisterConfirmationErrorModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    RegisterConfirmationComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RegisterConfirmationModule { }
